export default "__VITE_ASSET__9693e5c7__"